<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2><span>App Permission Risk</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon invisible" data-placement="top" data-toggle="tooltip" enTooltip
          title="Privacy and IVT risk that may result from the permissions an app is requesting from the user's device. ">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <img class="beta-tag" src="/assets/images/beta-tag.png" alt="Beta Tag" />
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12 px-0">
      <app-dangerous-permissions [isFreemium]="isFreemium" [isFollowing]="isFollowing"
        (followClick)="followButtonClick.emit($event)" [data]="data" (anchorClick)="anchorClick.emit($event)">
      </app-dangerous-permissions>
    </div>
  </div>
</div>
